import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { scrollToId, openInquiry } from "@/lib/scroll";
import { CONTACT } from "@/data/content";
import CAMPAIGN from "@/data/campaign";

const Header = () => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
    className="fixed top-8 left-0 right-0 z-50 backdrop-blur-2xl bg-[#F5F2EB]/70 border-b border-[#D2CFC7]/50"
    data-testid="site-header"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
      <button
        onClick={() => scrollToId("hero")}
        className="flex items-center gap-2 group"
        data-testid="header-logo"
      >
        <img
          src="/trekpanda-mark.png"
          alt="TrekPanda panda logo"
          className="h-9 w-auto transition-transform duration-300 group-hover:-translate-y-0.5"
        />
        <span className="font-heading text-2xl font-semibold tracking-tight text-foreground">
          TrekPanda
        </span>
        <span className="hidden sm:inline text-[10px] uppercase tracking-[0.25em] text-primary font-semibold mt-1">
          goes {CAMPAIGN.name}
        </span>
      </button>
      <div className="flex items-center gap-3 md:gap-6">
        <a
          href={CONTACT.phoneHref}
          className="hidden md:flex items-center gap-2 text-sm text-foreground/70 hover:text-primary transition-colors duration-300"
          data-testid="header-phone-link"
        >
          <Phone className="w-4 h-4" />
          {CONTACT.phoneDisplay}
        </a>
        <button
          onClick={openInquiry}
          className="bg-primary text-primary-foreground text-xs md:text-sm font-semibold uppercase tracking-[0.15em] px-4 md:px-6 py-2.5 hover:bg-[#2E9440] transition-colors duration-300"
          data-testid="header-cta-button"
        >
          Plan my trip
        </button>
      </div>
    </div>
  </motion.header>
);

export default Header;
